import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { name: '热门推荐', path: '/' },
    { name: '最新更新', path: '/' },
    { name: '恋爱浪漫', path: '/category/romance' },
    { name: '动作冒险', path: '/category/action' },
    { name: '奇幻魔法', path: '/category/fantasy' },
  ],
  about: [
    { name: '关于我们', path: '/about' },
    { name: '品牌故事', path: '/about' },
    { name: '联系我们', path: '/about' },
    { name: '版权声明', path: '/about' },
    { name: '隐私政策', path: '/about' },
  ],
  help: [
    { name: '阅读指南', path: '/about' },
    { name: '常见问题', path: '/' },
    { name: '意见反馈', path: '/about' },
    { name: '加入我们', path: '/about' },
    { name: '广告合作', path: '/about' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubscribeStatus('success');
      setSubscribeMsg('感谢订阅！');
      setEmail('');
      return;
    }
    if (!email.trim()) return;

    setSubscribeStatus('loading');
    try {
      const formData = new FormData();
      formData.append('email', email.trim());
      const res = await fetch('http://lhrkj3.com/api/form/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: email.trim() }).toString(),
      });
      const text = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(text); } catch { parsed = {}; }
      if (res.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setSubscribeStatus('error');
        setSubscribeMsg(msg);
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-[40%]">
            <Link to="/" className="font-label text-2xl text-primary-500">
              韩漫屋
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-sm">
              韩漫屋 — 您的韩漫在线阅读首选平台。提供海量免费韩国漫画大全，无删减下拉式韩漫，保证内容的原始风貌，为您带来最舒适的阅读体验。
            </p>

            <div className="mt-8">
              <p className="text-xs text-foreground-500 mb-3 font-medium">订阅更新</p>
              <form onSubmit={handleSubscribe} className="flex flex-col gap-3">
                <div className="honeypot-field">
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱获取最新漫画更新"
                  className="w-full bg-transparent border-b border-background-300 text-sm text-foreground-200 pb-2 outline-none transition-colors focus:border-primary-500 placeholder:text-foreground-600"
                  required
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className="w-fit px-5 py-2 text-sm font-medium border border-foreground-400 text-foreground-300 rounded-full whitespace-nowrap transition-all duration-200 hover:border-primary-500 hover:text-primary-500 cursor-pointer disabled:opacity-50"
                >
                  {subscribeStatus === 'loading' ? '提交中...' : '订阅'}
                </button>
                {subscribeStatus !== 'idle' && (
                  <p className={`text-xs ${subscribeStatus === 'success' ? 'text-primary-400' : 'text-red-400'}`}>
                    {subscribeMsg}
                  </p>
                )}
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            <div>
              <p className="text-sm font-medium text-foreground-200 mb-4">探索发现</p>
              <div className="flex flex-col gap-3">
                {footerLinks.explore.map((link) => (
                  <Link
                    key={link.name}
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-200 mb-4">关于我们</p>
              <div className="flex flex-col gap-3">
                {footerLinks.about.map((link) => (
                  <Link
                    key={link.name}
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-200 mb-4">帮助支持</p>
              <div className="flex flex-col gap-3">
                {footerLinks.help.map((link) => (
                  <Link
                    key={link.name}
                    to={link.path}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 韩漫屋 lhrkj3.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-foreground-500 hover:text-primary-500 transition-colors text-lg cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </span>
            <span className="text-foreground-500 hover:text-primary-500 transition-colors text-lg cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </span>
            <span className="text-foreground-500 hover:text-primary-500 transition-colors text-lg cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}